import { FlightFragment } from '@websky/graphql';

import { ExchangeSegmentsState } from '../model/types';

export function getInitialSegmentsState(segments: FlightFragment['segmentGroups']): ExchangeSegmentsState {
	const initialState: ExchangeSegmentsState = {};

	segments.forEach(segment => {
		initialState[segment.groupId] = {
			selectedDate: undefined,
			isSelected: false
		};
	});

	return initialState;
}
